<ol class="breadcrumb float-xl-right">
    <li class="breadcrumb-item">Inicio</li>
    <li class="breadcrumb-item">Administración Permisos de Acceso</li>
</ol>

<h1 class="page-header"><i class="fas fa-lock"></i> Permisos de Acceso</h1>

<panel [noButton]="true">
    <div class="toolbar">
        <button class="btn btn-primary btn-sm" (click)="openPermissionModal(modalPermission)">
            <i class="fas fa-plus"></i> Nuevo Permiso
        </button>
        <select class="form-select form-select-sm w-auto" [(ngModel)]="filterType" aria-label="Filtrar por tipo de permiso">
            <option value="backend">Backend</option>
            <option value="frontend">Frontend</option>
        </select>
    </div>

    @if (!matrixData) {
        <div class="alert alert-info">
            <i class="fas fa-info-circle"></i> Cargando matriz de permisos...
        </div>
    }
    @if (matrixData) {
        <div class="table-responsive">
            <table class="table table-sm table-hover">
                <thead>
                    <tr>
                        <th class="sticky-col">
                            {{ filterType === 'backend' ? 'Backend' : 'Frontend' }}
                        </th>
                        @for(r of matrixRoles; track r._id){
                        <th class="text-center">{{ r.name }}</th>
                        }
                    </tr>
                </thead>
                <tbody>
                    @for(row of filteredMatrix; track row.permission._id){
                    <tr>
                        <td class="sticky-col perm-name">
                            <a href="javascript:;"
                               (click)="openPermissionModal(modalPermission, row.permission)"
                               [attr.aria-label]="'Editar permiso ' + row.permission.name">
                                {{ row.permission.name }}
                            </a>
                        </td>
                        @for(r of matrixRoles; track r._id){
                        <td class="text-center">
                            <input class="form-check-input" type="checkbox"
                                [checked]="row.roles[r._id] === true"
                                (change)="toggleMatrix(row.permission._id, r._id, row.roles[r._id] !== true)"
                                [attr.aria-label]="(row.roles[r._id] === true ? 'Deshabilitar' : 'Habilitar') + ' permiso ' + row.permission.name + ' para rol ' + r.name"
                                [attr.title]="row.roles[r._id] === true ? 'Deshabilitar' : 'Habilitar'"/>
                        </td>
                        }
                    </tr>
                    }
                    @empty {
                    <tr>
                        <td [attr.colspan]="(matrixRoles?.length || 0) + 1" class="text-center">
                            No hay permisos de tipo "{{ filterType }}" registrados
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    }
</panel>

<ng-template #modalPermission let-c="close" let-d="dismiss">
    <div class="modal-header">
        <span class="fs-3 fw-700">Datos del Permiso</span>
    </div>
    <div class="modal-body" [formGroup]="permissionForm">
        <div class="row mb-3">
            <div class="col-md-8">
                <label class="form-label" for="perm-name">Nombre del Permiso</label>
                <input id="perm-name" type="text" class="form-control" placeholder="Ej: createRequest" formControlName="name" />
            </div>
            <div class="col-md-4">
                <label class="form-label" for="perm-type">Tipo</label>
                <select id="perm-type" class="form-select" formControlName="type">
                    <option value="backend">Backend</option>
                    <option value="frontend">Frontend</option>
                </select>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6">
                <label class="form-label" for="perm-level-min">Nivel Mínimo</label>
                <input id="perm-level-min" type="number" class="form-control" placeholder="1" formControlName="levelMin" min="1" />
                <small class="text-muted">El nivel más bajo (1 = administrador)</small>
            </div>
            <div class="col-md-6">
                <label class="form-label" for="perm-level-max">Nivel Máximo</label>
                <input id="perm-level-max" type="number" class="form-control" placeholder="5" formControlName="levelMax" min="1" />
                <small class="text-muted">El nivel más alto que aún tiene acceso</small>
            </div>
        </div>
        @if (permissionForm.value._id) {
        <hr />
        <div class="d-flex align-items-center justify-content-between mb-2">
            <strong class="fs-6">Reglas de Estado</strong>
            <button class="btn btn-outline-primary btn-sm" (click)="addStateRule()">
                <i class="fas fa-plus"></i> Agregar Regla
            </button>
        </div>
        @if (stateRules.length === 0) {
            <p class="text-muted small mb-0">Sin restricciones de estado. El permiso se evalúa solo por rol.</p>
        }
        @for (rule of stateRules; track rule._id) {
        <div class="card mb-2 border">
            <div class="card-body py-2 px-3">
                <div class="row g-2 align-items-center">
                    <div class="col-md-2">
                        <select class="form-select form-select-sm" [ngModel]="rule.entityName"
                            (ngModelChange)="rule.entityName = $event; saveStateRule(rule)">
                            @for (e of ENTITY_TYPES; track e) {
                            <option [value]="e">{{ e }}</option>
                            }
                        </select>
                    </div>
                    <div class="col-md-3">
                        <input class="form-control form-control-sm" placeholder="campo (ej: movement.priority)"
                            [ngModel]="rule.fieldPath"
                            (ngModelChange)="rule.fieldPath = $event; saveStateRule(rule)" />
                    </div>
                    <div class="col-md-2">
                        <select class="form-select form-select-sm" [ngModel]="rule.operator"
                            (ngModelChange)="rule.operator = $event; saveStateRule(rule)">
                            @for (op of OPERATORS; track op.value) {
                            <option [value]="op.value">{{ op.label }}</option>
                            }
                        </select>
                    </div>
                    <div class="col-md-3">
                        <input class="form-control form-control-sm" placeholder="valor"
                            [ngModel]="rule.value"
                            (ngModelChange)="rule.value = $event; saveStateRule(rule)" />
                    </div>
                    <div class="col-md-1">
                        <button class="btn btn-sm btn-outline-danger" (click)="removeStateRule(rule)">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                </div>
                <small class="text-muted">Regla: <code>{{ rule.entityName }}.{{ rule.fieldPath }} {{ getOperatorLabel(rule.operator) }} {{ rule.value }}</code></small>
            </div>
        </div>
        }
        }
    </div>
    <div class="modal-footer">
        <button class="btn btn-danger" (click)="d('Cross click')">Cerrar</button>
        <button class="btn btn-primary" (click)="d('Cross click'); savePermission(modalPermission)">Guardar</button>
    </div>
</ng-template>
